import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generarPDF = async (html, nombreArchivo = 'documento.pdf', ancho = 80) => {
    const tempContainer = document.createElement('div');
    tempContainer.className = 'isolated-print-theme ticket-impresion-container';
    tempContainer.style.position = 'fixed';
    tempContainer.style.left = '-99999px';
    tempContainer.style.top = '0';
    tempContainer.style.width = '300px';
    tempContainer.style.backgroundColor = '#ffffff';
    tempContainer.style.color = '#000000';
    tempContainer.style.zIndex = '-9999';

    const resetStyles = `
    <style>
      .isolated-print-theme,
      .isolated-print-theme * {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          background-color: transparent;
          box-sizing: border-box;
      }
      .isolated-print-theme strong,
      .isolated-print-theme b,
      .isolated-print-theme .font-weight-bold {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          font-weight: bold !important;
      }
    </style>
    `;

    tempContainer.innerHTML = resetStyles + html;
    document.body.appendChild(tempContainer);

    try {
        const canvas = await html2canvas(tempContainer, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff'
        });
        const jpegData = canvas.toDataURL('image/jpeg', 1.0);
        const scaleFactor = ancho / canvas.width;
        const alto = canvas.height * scaleFactor;

        const pdf = new jsPDF('p', 'mm', [ancho, alto]);
        pdf.addImage(jpegData, 'JPEG', 0, 0, ancho, alto);
        pdf.save(nombreArchivo);
    } catch (error) {
        console.error("Error al generar PDF:", error);
    } finally {
        if (document.body.contains(tempContainer)) {
            document.body.removeChild(tempContainer);
        }
    }
};
